import { render } from "./LandingTitleCompany.vue?vue&type=template&id=ed735e88&scoped=true&ts=true"
import script from "./LandingTitleCompany.vue?vue&type=script&lang=ts"
export * from "./LandingTitleCompany.vue?vue&type=script&lang=ts"

import "./LandingTitleCompany.vue?vue&type=style&index=0&id=ed735e88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed735e88"]])

export default __exports__